var _linearGradient, _path, _ellipse, _path2, _path3, _ellipse2, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Blender3D(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Oi_wi5LpyfLgcWZN6yf8Ta",
    x1: 1,
    x2: 45.667,
    y1: 25.776,
    y2: 25.776,
    gradientTransform: "matrix(1 0 0 -1 0 49.276)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa402"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f80"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Oi_wi5LpyfLgcWZN6yf8Ta)",
    d: "M39,16C35.612,13.527,26.115,5.591,26.115,5.591c-1.055-0.892-2.632-0.76-3.523,0.294 c-0.893,1.054-0.761,2.631,0.293,3.523L28.311,14H9.5C8.119,14,7,15.119,7,16.5S8.119,19,9.5,19h8.787L1.978,31.517 c-1.095,0.841-1.302,2.41-0.461,3.505C2.009,35.664,2.751,36,3.502,36c0.531,0,1.066-0.168,1.521-0.517l9.996-7.672 C15.016,27.927,15,28.038,15,28.154C15,35.971,21.532,42,30,42s15.667-6.029,15.667-13.846C45.667,23.275,42.876,18.83,39,16z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.5,
    cy: 27,
    fill: "#fff",
    rx: 9.75,
    ry: 9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5,18c5.385,0,9.75,4.029,9.75,9s-4.365,9-9.75,9s-9.75-4.029-9.75-9S25.115,18,30.5,18 M30.5,17.5 c-5.652,0-10.25,4.262-10.25,9.5s4.598,9.5,10.25,9.5s10.25-4.262,10.25-9.5S36.152,17.5,30.5,17.5L30.5,17.5z",
    opacity: 0.07
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5,17.5c5.652,0,10.25,4.262,10.25,9.5s-4.598,9.5-10.25,9.5S20.25,32.238,20.25,27S24.848,17.5,30.5,17.5 M30.5,17 c-5.928,0-10.75,4.486-10.75,10s4.822,10,10.75,10s10.75-4.486,10.75-10S36.428,17,30.5,17L30.5,17z",
    opacity: 0.05
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.5,
    cy: 27,
    fill: "#0370c8",
    rx: 5.5,
    ry: 5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5,21.5c3.308,0,6,2.467,6,5.5s-2.692,5.5-6,5.5s-6-2.467-6-5.5S27.192,21.5,30.5,21.5 M30.5,21 c-3.584,0-6.5,2.692-6.5,6s2.916,6,6.5,6s6.5-2.692,6.5-6S34.084,21,30.5,21L30.5,21z",
    opacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5,22c3.038,0,5.5,2.239,5.5,5s-2.462,5-5.5,5S25,29.761,25,27S27.462,22,30.5,22 M30.5,21.5c-3.308,0-6,2.467-6,5.5 s2.692,5.5,6,5.5s6-2.467,6-5.5S33.808,21.5,30.5,21.5L30.5,21.5z",
    opacity: 0.07
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Blender3D);
export default __webpack_public_path__ + "static/media/icons8-blender-3d.f3abe478164e9a516115600f17ac3ee3.svg";
export { ForwardRef as ReactComponent };